// Solitaire pricing — Magenta (default, no markup), Purple (+15%), Navy (+20%).
// Formula: RAP × USD × Carat × (1 − DISC/100) × (1 + Markup/100).
// GST adds 1.5% on top of the displayed final price.

export const MARKUPS = {
  magenta: 12,
  purple: 15,
  navy: 20,
};

export const DEFAULT_MARKUP = "magenta";

export function computeSolitairePrice(item, usdRate, markupKey = DEFAULT_MARKUP, gstOn = false) {
  const rap = Number(item?.rap || 0);
  const carat = Number(item?.carat || 0);
  const disc = Number(item?.disc_pct || 0); // typically negative
  const usd = Number(usdRate || 0);
  const markupPct = MARKUPS[markupKey] ?? 0;

  // Base USD price = RAP × Carat (per-carat × carats)
  const baseUsd = rap * carat;
  const baseInr = baseUsd * usd;
  // After discount — DISC column is e.g. -53 → multiplier 0.47
  const afterDisc = baseInr * (1 + disc / 100);
  // Apply markup
  const final = afterDisc * (1 + markupPct / 100);
  const gst = gstOn ? final * 0.015 : 0;
  const total = final + gst;
  return { baseUsd, baseInr, afterDisc, final, gst, total };
}

export const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
